import { AbstractControl, FormControl, Validators } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";
import { PriceyardService } from "src/app/modules/priceyard/services/priceyard.service";
import { GridActionsService } from "../../../../data-grid/grid-actions.service";
import { ValidatorDecimalInput } from "../../../../directives/decimal-number-validator";
import {RepriceListItem,SkuListItem} from "./../../../../models/priceyard.model";
import { SnackbarComponent } from '../../../../components/snackbar/snackbar.component';

@Component({
  selector: "app-sku-settings",
  templateUrl: "./sku-settings.component.html",
  styleUrls: ["./sku-settings.component.scss"],
})
export class SkuSettingsComponent implements OnInit, OnDestroy {
  _skus: SkuListItem[];
  get skus(): SkuListItem[] {
    return this._skus;
  }
  @Input() set skus(value: SkuListItem[]) {
    this._skus = value;
    this.addSingleSkuFields();
    this.fillMultiForm(this.skus);
    this.formData = { ...this.settingsForm.value };
  }
  @Output() viewEmitter: EventEmitter<boolean> = new EventEmitter();

  settingsForm: FormGroup = new FormGroup({
    Prmodel: this.newFormGroup("name", "isActive"),
    Map: this.setFormGroup("price", "isActive"),
    Markup: this.setFormGroup("price", "isAuto"),
    MinMarkup: this.setFormGroup("price", "isAuto"),
    DefaultPrice: this.setFormGroup("price", "isAuto"),
    //Single Only
  });
  isLoading: any = false;
  filteredOptions: any;
  options;
  formData: any;
  disableAutoFields = [
    "Cost",
    "Markup",
    "Min Markup",
    "Default Price",
    "Map Price",
  ];
  private destroy$ = new Subject<void>();

  constructor(
    private priceyardService: PriceyardService,
    private gridActionsService: GridActionsService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.priceyardService
      .GetPriceModel()
      .pipe(
        takeUntil(this.destroy$),
        map((models: any[]) =>
          models.filter(
            (model: RepriceListItem) =>
              model.marketPlace === this.skus[0].AccountType
          )
        )
      )
      .subscribe((e) => {
        this.options = e;
        this.filteredOptions = this.getPrModelName().valueChanges.pipe(
          takeUntil(this.destroy$),
          startWith(""),
          map((value) => this._filter(value))
        );

        // const myModel = this.sku.Prmodel.modelId;
        // const optionIndex = this.options
        //   .map((e) => {
        //     return e.modelId;
        //   })
        //   .indexOf(myModel);
        // this.getPrModelName().setValue(this.options[optionIndex]);
      });
    this.settingsForm
      .get("Prmodel")
      .patchValue({ isActive: true }, { emitEvent: false, onlySelf: true });

    this.settingsForm
      .get("Markup")
      .get("price")
      .valueChanges.pipe(takeUntil(this.destroy$)).subscribe((change) =>
        this.formValueChanges(change, "Markup", { isAuto: false })
      );
    this.settingsForm
      .get("Map")
      .get("price")
      .valueChanges.pipe(takeUntil(this.destroy$)).subscribe((change) =>
        this.formValueChanges(change, "Map", { isActive: false })
      );
    this.settingsForm
      .get("MinMarkup")
      .get("price")
      .valueChanges.pipe(takeUntil(this.destroy$)).subscribe((change) =>
        this.formValueChanges(change, "MinMarkup", { isAuto: false })
      );
    this.settingsForm
      .get("Minpr")
      .get("price")
      .valueChanges.pipe(takeUntil(this.destroy$)).subscribe((change) =>
        this.formValueChanges(change, "Minpr", { isAuto: false })
      );
    this.settingsForm
      .get("Maxpr")
      .get("price")
      .valueChanges.pipe(takeUntil(this.destroy$)).subscribe((change) =>
        this.formValueChanges(change, "Maxpr", { isAuto: false })
      );
    this.settingsForm
      .get("Prmodel")
      .get("name")
      .valueChanges.pipe(takeUntil(this.destroy$)).subscribe((change) =>
        this.formValueChanges(change, "Prmodel", { isActive: true })
      );

    this.settingsForm
      .get("DefaultPrice")
      .get("price")
      .valueChanges.pipe(takeUntil(this.destroy$)).subscribe((change) =>
        this.formValueChanges(change, "DefaultPrice", { isAuto: false })
      );
  }

  setFormGroup(keyName, autoKeyName): FormGroup {
    return new FormGroup({
      [keyName]: new FormControl("", [
        Validators.min(0),
        Validators.max(999999),
        ValidatorDecimalInput,
      ]),
      [autoKeyName]: new FormControl(),
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  formValueChanges(change, formName, element): void {
    this.settingsForm
      .get(formName)
      .patchValue(element, { emitEvent: false, onlySelf: true });
  }

  addSingleSkuFields() {
    this.settingsForm.addControl("Cost", this.setFormGroup("price", "isAuto"));
    this.settingsForm.addControl("Minpr", this.setFormGroup("price", "isAuto"));
    this.settingsForm.addControl("Maxpr", this.setFormGroup("price", "isAuto"));
    this.settingsForm.addControl("width", new FormControl());
    this.settingsForm.addControl("width", new FormControl());
    this.settingsForm.addControl("width", new FormControl());
    this.settingsForm.addControl("width", new FormControl());
    this.settingsForm.addControl("width", new FormControl());
    this.settingsForm.addControl("width", new FormControl());
    this.settingsForm.addControl("height", new FormControl());
    this.settingsForm.addControl("length", new FormControl());
    this.settingsForm.addControl("weight", new FormControl());
  }

  fillMultiForm(skus: SkuListItem[]) {
    Object.keys(this.settingsForm.controls).forEach((element) => {
      const control = this.settingsForm.controls[element] as FormGroup;
      if (control.controls) {
        // Object.keys(control.controls).forEach((childElement) => {
        //   const childControl = control.controls[childElement];
        //   const UniqueValueCount = [
        //     ...new Set(
        //       skus.map((sku: SkuListItem) => {
        //         if (sku[element]) {
        //           return sku[element][childElement]
        //         }
        //       })
        //     ),
        //   ];
        //   const controlValue =
        //     UniqueValueCount.length === 1
        //       ? skus[0][element][childElement]
        //       : "Multiple";
        //   childControl.setValue(controlValue);
        // });
        // if it is not a group
      } else {
        const UniqueValueCount = [
          ...new Set(skus.map((sku: SkuListItem) => sku[element])),
        ];
        const controlValue =
          UniqueValueCount.length === 1 ? skus[0][element] : "Multiple";
        control.setValue(controlValue);
      }
    });
  }

  submit() {
    this.isLoading = true;
    const formControls = this.settingsForm.controls;
    Object.keys(formControls).forEach((element) => {
      const control = this.settingsForm.controls[element] as FormGroup;
      if (control.controls) {
        Object.keys(control.controls).forEach((childElement) => {
          const childControl = control.controls[childElement];
          this.checkAndExecute(childControl, element, childElement);
        });
      } else {
        this.checkAndExecute(control, element);
      }
    });
    if (
      this.settingsForm.value["Maxpr"]?.price <
      this.settingsForm.value["Minpr"]?.price
    ) {
      this.isLoading = false;
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Min Price is more than Max Price',
              action: 'Dismiss',
              type: 'info',
            },
          }
      );
    } else {
      this.changePriceFactor();
    }
  }

  checkAndExecute(
    formControl: AbstractControl,
    controlName: string,
    childControlName?: string
  ) {
    if (!formControl.pristine && formControl.value !== "Multiple") {
      switch (controlName) {
        case "prModel":
          // change pr model
          break;
        case "Costpr":
          this.changeCost(formControl.value);
          break;
        default:
        // code block
      }
    }
  }

  displayFn(model): string {
    return model && model.name ? model.name : "";
  }

  getPrModelName() {
    return this.settingsForm.get("Prmodel").get("name");
  }

  private _filter(value: any): string[] {
    const filterValue =
      typeof value === "string"
        ? value.toLowerCase()
        : value?.name.toLowerCase();
    return this.options.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  newFormGroup(value, isOn) {
    return new FormGroup({
      [value]: new FormControl(""),
      [isOn]: new FormControl(""),
    });
  }

  // Actions
  changeCost(cost) {
    const skus = this.skus.map((sku: SkuListItem) => sku.Sku);
    this.priceyardService
      .ChangeCost(
        skus,
        this.skus[0].Account,
        cost,
        this.skus[0].FulfillmentType
      ).pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
      });
  }

  changePriceFactor() {
    const skusList = { skus: [] };
    const modelName = this.options.find(
      (option) =>
        option.modelId ===
        Number(this.settingsForm.get("Prmodel").value["name"])
    )?.name;
    const pricingOn = this.settingsForm.get("Prmodel").value.isActive;
    this.skus.forEach((skuItem) => {
      const formElement = [];
      const formControls = this.settingsForm.controls;
      Object.keys(formControls).forEach((element) => {
        const control = this.settingsForm.controls[element] as FormGroup;
        if (!control.pristine && element !== "Prmodel") {
          let priceFactor;
          if (control.controls) {
            let elementValue =
              control.controls[control.controls?.price ? "price" : "name"]
                .value;
            elementValue =
              element === "Markup" ? elementValue / 100 : elementValue;
            const setAuto =
              control.controls[
                control.controls?.isActive ? "isActive" : "isAuto"
              ].value;
            const factor = this.convertName(element);
            priceFactor = {
              value: elementValue
                ? elementValue
                : element === "DefaultPrice"
                ? this.skus[0].DefaultPrice
                : this.skus[0][element].Price,
              factor,
            };
            if (!this.disableAutoFields.includes(factor) && isNaN(priceFactor.value)) {
              priceFactor["setAuto"] = setAuto;
            }
          } else {
            priceFactor = {
              value: parseFloat(control.value),
              factor: this.convertName(element),
            };
          }
          if (!isNaN(priceFactor.value)) {
            formElement.push(priceFactor);
          }
        }
      });

      skusList.skus.push({
        sku: skuItem.Sku,
        account: skuItem.Account,
        fulfillmentType: skuItem.FulfillmentType,
        changingFactors: formElement,
        modelName,
        pricingOn,
      });
    });
    this.priceyardService.changePriceFactor(skusList.skus).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response && Object.keys(response).length === 0) {
          this.gridActionsService.refreshData();
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Price changes saved successfully',
                  action: 'Dismiss',
                  type: 'success',
                },
              }
          );
        }
      },
     error: (error) => {
        this.isLoading = false;
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Failed to save price changes, please try again.',
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
      }
      }
    );
  }

  convertName(name) {
    switch (name) {
      case "Minpr":
        return "Min Price";
      case "Maxpr":
        return "Max Price";
      case "DefaultPrice":
        return "Default Price";
      case "Markup":
        return "Markup";
      case "MinMarkup":
        return "Min Markup";
      case "Map":
        return "Map Price";
      case "Cost":
        return "Cost";
      case "PrepCost":
        return "Prep Cost";
      default:
        return name;
        break;
    }
  }

  resetForm() {
    this.fillMultiForm(this.skus);
  }

  view() {
    this.viewEmitter.emit(true);
  }


  
}
